export function cleanAndFormatText(text) {
  if (!text) return '';
  if (typeof text === 'object') {
    text = JSON.stringify(text, null, 2);
  }
  return text.toString();
}

export function formatText(text, prompt = '') {
  if (!text) return '';
  text = cleanAndFormatText(text);

  const explicitlyRequestsBulletPoints =
    prompt.toLowerCase().includes("bullet point") ||
    prompt.toLowerCase().includes("bullet-point") ||
    prompt.toLowerCase().includes("bulletpoint");

  let formatted = text
    .replace(/```[a-z]*|```/g, '')
    .replace(/^\s*###\s*/gm, '')
    .replace(/^\s*####\s*/gm, '')
    .replace(/\*\*\*(.*?)\*\*\*/g, '<strong style="color: #dc2626; font-weight: 700;">$1</strong>')
    .replace(/\*\*!(.*?)!\*\*/g, '<strong style="color: #dc2626; font-weight: 700;">$1</strong>')
    .replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');

  if (explicitlyRequestsBulletPoints) {
    const hasBulletPoints = /^\s*[-•*]\s+|^\s*\d+\.\s+/gm.test(text);
    if (hasBulletPoints) {
      formatted = formatted
        .replace(/^\s*[-•]\s*(.*?)(?=\n|$)/gm, '___BULLET_START___$1___BULLET_END___')
        .replace(/^\s*\*\s*(.*?)(?=\n|$)/gm, '___BULLET_START___$1___BULLET_END___')
        .replace(/^\s*\d+\.\s*(.*?)(?=\n|$)/gm, '___BULLET_START___$1___BULLET_END___');

      formatted = formatted.replace(/___BULLET_START___(.*?)___BULLET_END___/g, (match, content) => {
        return `<div class="flex gap-2 items-start mt-1.5"><span class="mt-[5px] w-1.5 h-1.5 rounded-full flex-shrink-0" style="background-color:var(--color-primary);opacity:0.55;"></span><span class="leading-relaxed">${content}</span></div>`;
      });
    }
  }

  formatted = formatted
    .replace(/\n/g, '')
    .replace(/\s+/g, ' ')
    .trim()
    .replace(/<br><br>/g, '<br>')
    .replace(/(•\s*<br>\s*){2,}/g, '<br>')
    .replace(/•\s*([^<\s])/g, '• $1');

  return formatted;
}

